import React from 'react';
import '../styles.css';

const AccessModal = ({ assetToAccess }) => {
  return (
    <ul>
      {assetToAccess?.users_access?.map(({ first_name, last_name, user_id }) => (
        <li className="list-item" key={user_id}>
          <div className="recipient-avatar">
            {first_name[0]}
            {last_name[0]}
          </div>
          <div>
            {first_name} {last_name}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default AccessModal;
